/**
 * 管理端视图 URL 状态同步
 * 约定：参数名 = `${prefix}_${key}`，例如 users_page、jobs_status
 */

function safeInt(value, fallback) {
  const n = parseInt(String(value || ""), 10);
  return Number.isFinite(n) && n > 0 ? n : fallback;
}

export function readScopedQuery(prefix, schema) {
  const params = new URLSearchParams(window.location.search);
  const state = {};
  Object.entries(schema).forEach(([key, conf]) => {
    const raw = params.get(`${prefix}_${key}`);
    if (raw == null || raw === "") {
      state[key] = conf.defaultValue;
      return;
    }
    if (conf.type === "int") {
      state[key] = safeInt(raw, conf.defaultValue);
      return;
    }
    state[key] = raw;
  });
  return state;
}

export function writeScopedQuery(prefix, state) {
  const url = new URL(window.location.href);
  Object.entries(state).forEach(([key, value]) => {
    const paramKey = `${prefix}_${key}`;
    const normalized = value == null ? "" : String(value).trim();
    if (!normalized) {
      url.searchParams.delete(paramKey);
    } else {
      url.searchParams.set(paramKey, normalized);
    }
  });
  history.replaceState(null, "", url.pathname + url.search + url.hash);
}
